import { Carousel, IconButton, useBreakpointValue } from "@chakra-ui/react"
import { PublicationCarouselPreviewProps } from "../../api/landingpage"
import PublicationPreview from "./PublicationPreview"
import { FiChevronLeft, FiChevronRight } from "react-icons/fi"
import { useState } from "react"


const PublicationCarouselPreview = ({publications} : PublicationCarouselPreviewProps) => {
    const slidesPerPage = useBreakpointValue({
        base: 1,
        lg: 1,
        xl: 3,
        "2xl": 4,
    }, { fallback: "base" })

    const [hasInteracted, setHasInteracted] = useState(false)

    return (
        <Carousel.Root
            mx="auto"
            w="full"
            maxW="100vw"
            gap={5}
            loop={true}
            allowMouseDrag
            slideCount={publications.length}
            slidesPerPage={slidesPerPage}
            autoplay={hasInteracted ? false : { delay: 4000 }}
            onDragStart={() => setHasInteracted(true)}
            onPointerDown={() => setHasInteracted(true)}
        >
            <Carousel.Control justifyContent="center" gap="4" width="full">
                <Carousel.PrevTrigger asChild hideBelow="md">
                    <IconButton color="main" bgColor="transparent">
                        <FiChevronLeft width={10} height={10} />
                    </IconButton>
                </Carousel.PrevTrigger>

                <Carousel.ItemGroup w="full">
                    {publications.map((pub, index) => (
                        <Carousel.Item key={index} index={index}>
                            <PublicationPreview publication={pub} />
                        </Carousel.Item>
                    ))}
                </Carousel.ItemGroup>

                <Carousel.NextTrigger asChild hideBelow="md">
                    <IconButton color="main" bgColor="transparent">
                        <FiChevronRight width={10} height={10} />
                    </IconButton>
                </Carousel.NextTrigger>
            </Carousel.Control>

            <Carousel.Indicators />
        </Carousel.Root>
    )
}

export default PublicationCarouselPreview
